import applicationUserManager from './applicationusermanager'

const checksecmixin = {
    data() {
        return {
            user: {
                name: '',
                isAuthenticated: false
            }
        }
    },
    //async created() {
    //    await this.refreshUserInfo()
    //},
    //watch: {
    //    async '$route'() {
    //        await this.refreshUserInfo()
    //    }
    //},
    methods: {
        async refreshUserInfo() {
            const user = await applicationUserManager.getUser()
            if (!user) {
                this.$router.replace({ name: "login" });
            }
        }
    }
}

export default checksecmixin